import { render, staticRenderFns } from "./FilterBusinessEventField.vue?vue&type=template&id=667e2ad1"
import script from "./FilterBusinessEventField.vue?vue&type=script&lang=ts"
export * from "./FilterBusinessEventField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/filter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2Fform%2FFilterBusinessEventField.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports